import React from 'react';
import Button from '../../components/buttons/Button';
import { FaUserSlash, FaUserPlus } from 'react-icons/fa';

const UsersTab = ({
  users,
  inviteEmail,
  inviteAdmin,
  loading,
  setInviteEmail,
  setInviteAdmin,
  handleInvite,
  removeUser,
  toggleAdmin
}) => {
  return (
    <div className="enterprise-admin-users-tab">
      <h2>Gestion des utilisateurs</h2>
      
      <div className="enterprise-admin-invite-user">
        <h3>Inviter un utilisateur</h3>
        <div className="enterprise-admin-invite-form">
          <input 
            type="email" 
            placeholder="Email" 
            value={inviteEmail} 
            onChange={e => setInviteEmail(e.target.value)} 
          />
          <label className="enterprise-admin-checkbox">
            <input 
              type="checkbox" 
              checked={inviteAdmin} 
              onChange={e => setInviteAdmin(e.target.checked)} 
            />
            Administrateur
          </label>
          <Button 
            onClick={handleInvite} 
            disabled={loading || !inviteEmail}
            icon={FaUserPlus}
          >
            Inviter
          </Button>
        </div>
      </div>

      <div className="enterprise-admin-users-table-container">
        <h3>Utilisateurs ({users.length})</h3>
        {loading ? (
          <p>Chargement des utilisateurs...</p>
        ) : users.length === 0 ? (
          <p>Aucun utilisateur trouvé.</p>
        ) : (
          <table className="enterprise-admin-users-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Rôle</th>
                <th>Date d'ajout</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.userId}>
                  <td data-label="Nom">{user.fullName}</td>
                  <td data-label="Email">{user.email}</td>
                  <td data-label="Rôle">
                    <span className={`enterprise-admin-status-badge ${user.isAdmin ? 'active' : 'inactive'}`}>
                      {user.isAdmin ? 'Administrateur' : 'Utilisateur'}
                    </span>
                  </td>
                  <td data-label="Date d'ajout">
                    {user.createdAt ? new Date(user.createdAt).toLocaleDateString('fr-FR') : '-'}
                  </td>
                  <td data-label="Actions">
                    <Button
                      type="inversed"
                      variant="warning"
                      onClick={() => {
                        const action = user.isAdmin ? 'retirer les droits administrateur de' : 'donner les droits administrateur à';
                        const confirmMessage = `Êtes-vous sûr de vouloir ${action} ${user.fullName} ?`;
                        if (window.confirm(confirmMessage)) {
                          toggleAdmin(user);
                        }
                      }}
                      disabled={loading}
                      title={user.isAdmin ? 'Retirer les droits admin' : 'Donner les droits admin'}
                    >
                      {user.isAdmin ? 'Retirer admin' : 'Donner admin'}
                    </Button>
                    <Button
                      type="inversed"
                      variant="danger"
                      onClick={() => {
                        const confirmMessage = `Êtes-vous sûr de vouloir supprimer l'utilisateur ${user.fullName} ? Cette action est irréversible.`;
                        if (window.confirm(confirmMessage)) {
                          removeUser(user.userId);
                        }
                      }}
                      disabled={loading}
                      title="Retirer l'utilisateur"
                    >
                      <FaUserSlash /> Supprimer
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default UsersTab; 